export default __webpack_public_path__ + "static/media/room1-MASK-Zahner1.ef386a6c.png";